import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UIConfig {
  precisionProvider: { getPrecision(code: string): number } = { getPrecision: () => 2 };
}
